


  const dropdown = document.getElementById('acv-ul');
  const selectedNav = document.getElementById('selectedNav');

  const acvState = {
    selectedMake: '',
  };
  let autoFocusedFirst = false;

  const fetchData = async (url) => {
    try {
      const response = await fetch(url, { mode: 'cors' });
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch data', error);
    }
  };

  const appendLiGroups = (el, groupTitle, arr, type, liClass) => {
    if (!arr.length) return;

    const headLi = document.createElement('li');
    headLi.textContent = groupTitle;
    headLi.classList.add('li-head');
    el.appendChild(headLi);

    arr.sort().forEach((each) => {
      const li = document.createElement('li');
      li.dataset.type = type;
      li.dataset.value = each;
      li.classList.add(liClass);

      if (type === 'model') {
        const modelName = each.replace(new RegExp(`^${acvState.selectedMake}\\s+`, 'i'), '');
        li.textContent = modelName;

        const product = findProductByModel(each);
        if (product) {
          const ratingSpan = document.createElement('span');
          ratingSpan.className = 'loox-rating';
          ratingSpan.setAttribute('data-id', product.id);
          ratingSpan.setAttribute('data-rating', product.rating);
          ratingSpan.setAttribute('data-raters', product.reviews);
          li.appendChild(ratingSpan);
        }
      } else {
        li.textContent = each;
      }

      el.appendChild(li);
    });
  };

  const handleMakeSelection = () => {
    const makeElements = document.querySelectorAll('.li-make');
    makeElements.forEach((li) => {
      li.addEventListener('click', (e) => {
        dropdown.innerHTML = '';
        const selectedMake = e.currentTarget.dataset.value;
        acvState.selectedMake = selectedMake;

        const modelList = getModelsByMake(selectedMake);
        const { bestSellers, others } = splitByBestSellers(modelList, getAllBestSellerModels());

        appendLiGroups(dropdown, `Best Sellers`, bestSellers, 'model', 'li-model');
        appendLiGroups(dropdown, `Models`, others, 'model', 'li-model');
        selectedNav.style.display = "block";
        selectedNav.innerHTML = `<div>
          <span>Selected Make:</span>
          <span>${selectedMake}</span>
        </div>`
        
        handleModelSelection();
        document.getElementById('acv-back-button').dataset.back = "makeBack"
        
        dropdown.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

      });
    });
  };

  const handleModelSelection = () => {
    const modelElements = document.querySelectorAll('.li-model');
    modelElements.forEach((li) => {
      li.addEventListener('click', (e) => {

      document.getElementById('acv-back-button').dataset.back = "initial"; 
      dropdown.style.pointerEvents = "none";

        const spinnerHTML = `
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke="#fc3" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `;

        e.target.insertAdjacentHTML("beforeend", spinnerHTML);




        const model = e.currentTarget.dataset.value;
        const handle = model.trim().toLowerCase().replace(/\s+/g, '-');
        window.location.href = `/products/${handle}`;
      });
    });
  };

  const getModelsByMake = (make) => {
    const match = window.makeModelData.find((item) => item.make === make);
    return match ? match.models : [];
  };

  const getAllBestSellerModels = () => {
    const bestSellerModels = new Set();
    window.collectionProductList.forEach((group) => {
      group.products.forEach((product) => {
        bestSellerModels.add(product.model);
      });
    });
    return bestSellerModels;
  };

  const splitByBestSellers = (list, bestSet) => {
    const bestSellers = [];
    const others = [];

    list.forEach((item) => {
      if (bestSet.has(item)) {
        bestSellers.push(item);
      } else {
        others.push(item);
      }
    });

    return { bestSellers, others };
  };

  const findProductByModel = (modelName) => {
    for (const group of window.collectionProductList) {
      const match = group.products.find((p) => p.model === modelName);
      if (match) return match;
    }
    return null;
  };

const selectorACV = document.querySelector('.selector-collection.selector-acv');

if (selectorACV) {
  selectorACV.addEventListener('click', async () => {
    const data = await fetchData("//pedalcommander.com/cdn/shop/t/265/assets/makeModel.json?v=128090689508164248651792086380");

    if (!data || !window.collectionProductList) return;

    window.makeModelData = data.createdMakeModel;
    console.log("makeModelData-init", makeModelData);

    const allMakesSet = new Set();
    const bestSellerMakesSet = new Set();

    data.createdMakeModel.forEach((item) => {
      allMakesSet.add(item.make);
    });

    window.collectionProductList.forEach((group) => {
      group.products.forEach((product) => {
        const make = product.model.split(' ')[0];
        bestSellerMakesSet.add(make);
      });
    });

    const bestSellerMakes = [];
    const normalMakes = [];

    allMakesSet.forEach((make) => {
      if (bestSellerMakesSet.has(make)) {
        bestSellerMakes.push(make);
      } else {
        normalMakes.push(make);
      }
    });

    dropdown.innerHTML = '';

    appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
    appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');

    handleMakeSelection();
    handleSearch();
    handleKeyboardNavigation();
  });
}







const handleSearch = () => {
  const input = document.getElementById('acv-search');
  input.addEventListener('input', (e) => {
    const query = e.target.value.trim().toLowerCase();
    dropdown.innerHTML = '';

    if (!query) {
      acvState.selectedMake = '';

      const allMakes = window.makeModelData.map(entry => entry.make);
      const uniqueMakes = [...new Set(allMakes)];

      const bestSellerMakes = [];
      const normalMakes = [];

      uniqueMakes.forEach((make) => {
        if (getAllBestSellerMakes().has(make)) {
          bestSellerMakes.push(make);
        } else {
          normalMakes.push(make);
        }
      });

      appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
      appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
      handleMakeSelection();
      return;
    }

    let foundSomething = false;

    if (acvState.selectedMake) {
      const modelMatches = getMatchedModels(query);
      if (modelMatches.length) {
        appendSearchResults('Models', modelMatches, 'model', 'li-model', query);
        foundSomething = true;
      }
    } else {
      const makeMatches = getMatchedMakes(query);
      const modelMatches = getMatchedModels(query);

      if (makeMatches.length) {
        appendSearchResults('Makes', makeMatches, 'make', 'li-make', query);
        foundSomething = true;
      }

      if (modelMatches.length) {
        appendSearchResults('Models', modelMatches, 'model', 'li-model', query);
        foundSomething = true;
      }
    }

    attachSearchResultHandlers();


    // focus first item only first time
    autoFocusedFirst = false;
    setTimeout(() => {
      if (!autoFocusedFirst) {
        const items = dropdown.querySelectorAll('li.li-make, li.li-model');
        if (items.length > 0) {
          focusedIndex = 0;
          updateFocus(items, focusedIndex);
          autoFocusedFirst = true;
        }
      }
    }, 0);

  if (!foundSomething) {
      const li = document.createElement('li');
      li.textContent = 'No results found.';
      li.style.color = 'gray';
      li.style.padding = '10px';
      dropdown.appendChild(li);
    }

  










  });
};



const getAllBestSellerMakes = () => {
  if (window.bestSellerMakeSet) return window.bestSellerMakeSet;

  const bestSellerMakes = new Set();
  window.collectionProductList.forEach((group) => {
    group.products.forEach((product) => {
      const make = product.model.split(' ')[0];
      bestSellerMakes.add(make);
    });
  });

  window.bestSellerMakeSet = bestSellerMakes; // for performance 
  return bestSellerMakes;
};




const getMatchedMakes = (query) => {
  return window.makeModelData
    .map((entry) => entry.make)
    .filter((make, i, arr) => arr.indexOf(make) === i && make.toLowerCase().includes(query));
};

const getMatchedModels = (query) => {
  const scope = acvState.selectedMake
    ? window.makeModelData.filter((item) => item.make === acvState.selectedMake)
    : window.makeModelData;

  return scope
    .flatMap((entry) => entry.models)
    .filter((model, i, arr) => arr.indexOf(model) === i && model.toLowerCase().includes(query));
};

const highlightMatch = (text, query) => {
  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<span style="color:red;">$1</span>');
};

const appendSearchResults = (title, list, type, className, query) => {
  if (!list.length) return;

  const headLi = document.createElement('li');
  headLi.textContent = title;
  headLi.classList.add('li-head');
  dropdown.appendChild(headLi);

  const regex = new RegExp(`(${query})`, 'gi');

  list.forEach((item) => {
    const li = document.createElement('li');
    li.dataset.type = type;
    li.dataset.value = item;
    li.classList.add(className);

    const parts = item.split(regex);
    parts.forEach((part) => {
      const span = document.createElement('span');
      span.textContent = part;
      if (part.toLowerCase() === query.toLowerCase()) {
        span.style.color = 'red';
      }
      li.appendChild(span);
    });

    dropdown.appendChild(li);
  });
};


const attachSearchResultHandlers = () => {
  const makeEls = document.querySelectorAll('.li-make');
  const modelEls = document.querySelectorAll('.li-model');

  makeEls.forEach((li) => {
    li.addEventListener('click', () => {
      document.getElementById('acv-back-button').dataset.back = "initial"; 
      const selectedMake = li.dataset.value;
      acvState.selectedMake = selectedMake;

      const modelList = getModelsByMake(selectedMake);
      const { bestSellers, others } = splitByBestSellers(modelList, getAllBestSellerModels());

      dropdown.innerHTML = '';
      appendLiGroups(dropdown, `Best Sellers`, bestSellers, 'model', 'li-model');
      appendLiGroups(dropdown, `Models`, others, 'model', 'li-model');
              selectedNav.style.display = "block";
        selectedNav.innerHTML = `<div>
          <span>Selected Make:</span>
          <span>${selectedMake}</span>
        </div>`

      handleModelSelection();
      document.getElementById('acv-search').value = '';

      document.getElementById('acv-back-button').dataset.back = "makeBack"

    });
  });

  modelEls.forEach((li) => {
    li.addEventListener('click', () => {
      document.getElementById('acv-back-button').dataset.back == "initial"
      const model = li.dataset.value;
      const handle = model.trim().toLowerCase().replace(/\s+/g, '-');
      window.location.href = `/products/${handle}`;
    });
  });
};



 const handleKeyboardNavigation = () => {
  const input = document.getElementById('acv-search');

  let focusedIndex = -1;

  input.addEventListener('keydown', (e) => {
    const items = dropdown.querySelectorAll('li.li-make, li.li-model');
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusedIndex = (focusedIndex + 1) % items.length;
      updateFocus(items, focusedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      focusedIndex = (focusedIndex - 1 + items.length) % items.length;
      updateFocus(items, focusedIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (focusedIndex >= 0 && items[focusedIndex]) {
        items[focusedIndex].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      input.value = '';
      dropdown.innerHTML = '';
      focusedIndex = -1; 
      acvState.selectedMake = '';

      const allMakes = window.makeModelData.map(entry => entry.make);
      const uniqueMakes = [...new Set(allMakes)];

      const bestSellerMakes = [];
      const normalMakes = [];

      uniqueMakes.forEach((make) => {
        if (getAllBestSellerMakes().has(make)) {
          bestSellerMakes.push(make);
        } else {
          normalMakes.push(make);
        }
      });

      appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
      appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
      handleMakeSelection();
    }
  });
};

const updateFocus = (items, index) => {
  items.forEach((item, i) => {
    if (i === index) {
      item.classList.add('focused');
      item.scrollIntoView({ block: 'nearest' });
    } else {
      item.classList.remove('focused');
    }
  });
};



    function toggleVisibility(element, isShow) {
      if (element) element.style.display = isShow ? "flex" : "none";
    }


document.getElementById('acv-back-button').addEventListener('click', () => {
  selectedNav.style.display = "none";
  let backType = document.getElementById('acv-back-button').dataset.back;

    if (backType === "initial") {
            toggleVisibility(document.querySelector(".c-hp-video-banner-content"), true);
            toggleVisibility(document.querySelector("#us-collection-selector"), true);
            toggleVisibility(document.querySelector("#acv-wrapper"), false);
            document.querySelector(".c-hp-video-banner-container").classList.remove("heightArrange");
            document.querySelector(".c-hp-video-banner-content-wrapper").style.justifyContent = "space between";


    } else if (backType === "makeBack") {

   
  acvState.selectedMake = '';
  document.getElementById('acv-search').value = '';
  dropdown.innerHTML = '';
  document.getElementById('acv-back-button').dataset.back = "initial"; 
  dropdown.style.pointerEvents = "auto";
  
  const allMakes = window.makeModelData.map(entry => entry.make);
  const uniqueMakes = [...new Set(allMakes)];

  const bestSellerMakes = [];
  const normalMakes = [];

  uniqueMakes.forEach((make) => {
    if (getAllBestSellerMakes().has(make)) {
      bestSellerMakes.push(make);
    } else {
      normalMakes.push(make);
    }
  });

  appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
  appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
  handleMakeSelection();
   } 
});




 const getClosestMatch = (query, list) => {
  let closest = '';
  let shortestDistance = Infinity;

  list.forEach(item => {
    const distance = levenshteinDistance(query.toLowerCase(), item.toLowerCase());
    if (distance < shortestDistance) {
      shortestDistance = distance;
      closest = item;
    }
  });

  return shortestDistance <= 3 ? closest : null; // çok uzaksa önermeyiz
};

const levenshteinDistance = (a, b) => {
  const matrix = Array.from({ length: a.length + 1 }, () => []);

  for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,    // deletion
        matrix[i][j - 1] + 1,    // insertion
        matrix[i - 1][j - 1] + cost // substitution
      );
    }
  }

  return matrix[a.length][b.length];
};


